import React from 'react';

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  color?: 'primary' | 'teal' | 'white';
}

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ 
  size = 'md',
  color = 'primary' 
}) => {
  const sizeClasses = {
    sm: 'w-4 h-4',
    md: 'w-8 h-8',
    lg: 'w-12 h-12'
  };

  const colorClasses = {
    primary: 'border-red-500',
    teal: 'border-teal-500',
    white: 'border-white'
  };

  return (
    <div 
      className={`
        ${sizeClasses[size]} 
        border-4 
        ${colorClasses[color]} 
        border-t-transparent 
        rounded-full 
        animate-spin
      `}
    />
  );
};